import React from 'react';

import logo from 'assets/images/new-login/logo.svg';

import { Container, Content, Logo } from './styles';

const AuthHeader: React.FC = () => {
  return (
    <Container>
      <Content>
        <Logo src={logo} alt="Ultragaz" />
      </Content>
    </Container>
  );
};

export default AuthHeader;
